import PropTypes from 'prop-types'

import Autocomplete from 'beam/dist/next/Autocomplete'
import { TextField } from 'beam/dist/TextField'
import { fieldToTextField } from 'formik-material-ui'

const FormAutocompleteField = ({ textFieldProps, handleChange, renderInput, ...props }) => {
  const {
    form: { setTouched },
  } = props
  const { error, helperText, ...field } = fieldToTextField(props)
  const { name } = field

  return (
    <Autocomplete
      blurOnSelect={props.multiple ? false : true}
      {...props}
      {...field}
      onChange={handleChange}
      onBlur={() => setTouched({ [name]: true })}
      renderInput={renderInput ? renderInput : props => (<TextField {...props} {...textFieldProps} helperText={helperText} error={error} />)
      }
    />
  )
}

FormAutocompleteField.propTypes = {
  textFieldProps: PropTypes.object,
  form: PropTypes.object,
  renderInput: PropTypes.func,
  multiple: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
}

export default FormAutocompleteField
